module.exports = {
      id: "line-arrow-next-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#line-arrow-next",
      toString: function () {
        return this.url;
      }
    }